import { Directive, Input, Inject } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { UserService } from '../services/user.service';

@Directive({
  selector: '[browsepathvalidate]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: BrowsePathValidateDirective,
      multi: true,
    },
  ],
})
export class BrowsePathValidateDirective implements Validator {
  @Input('browsepathvalidate') libraryName!: string;

  constructor(@Inject('browseService') private browseService: any, private userService: UserService) {}

  validate(control: AbstractControl): ValidationErrors | null {
	if (!this.libraryName) {
      return { browsepathvalidate: { valid: false, message: 'Library name is missing' } };
    }  
    if (!control.value) {
      return null; // No validation error for empty values
    }

    const currentBrowse: string[] = [];
    const validBrowse: string[] = [];
    const paths = control.value.split(this.browseService.pathSeparator);

    for (let i = 0; i < paths.length; i++) {
      const browseField = paths[i].split(/:(.*)/);
      if (!browseField[0] || !browseField[1]) {
        return { browsepathvalidate: { valid: false, message: 'Invalid path format' } };
      }
      currentBrowse.push(browseField[0]);
    }

    const library = this.userService.user?.properties?.awlibraryObjectList.find(
      (lib: any) => lib.name === this.libraryName
    );

    if (!library) {
      return { browsepathvalidate: { valid: false, message: 'Library not found' } };
    }

    for (let i = 0; i < library.awhierarchyObject.length; i++) {
      validBrowse.push(library.awhierarchyObject[i].hierarchyName);
    }

    const result = currentBrowse.every((val) => validBrowse.includes(val));

    return result ? null : { browsepathvalidate: { valid: false, message: 'Invalid browse path' } };
  }
}